import { IconPlane, IconShieldCheck, IconUsersGroup, IconWorld } from "@tabler/icons-react";
import { useLocaleContext } from "src/context/locale-context";
import { getHeroImageUrl } from "src/utils/hero-image-utils";
import classes from "./Hero.module.css";

const BENEFITS = [
  { key: "home.hero.benefit.years", icon: IconShieldCheck },
  { key: "home.hero.benefit.clients", icon: IconUsersGroup },
  { key: "home.hero.benefit.worldwide", icon: IconWorld },
];

export function Hero({ showImage = true }) {
  const { getStringRes, currentLanguage } = useLocaleContext();
  const heroImageUrl = showImage ? getHeroImageUrl(currentLanguage) : null;

  // The per-language banner already has its own heading/tagline baked into the graphic, so our
  // own text overlay would double up on top of it — only render ours as a fallback when there's
  // no dedicated image for the current language (or when this page opted out via showImage).
  if (heroImageUrl) {
    return (
      <div
        className={`${classes.hero} ${classes.heroWithImage}`}
        style={{ backgroundImage: `url("${heroImageUrl}")` }}
      />
    );
  }

  return (
    <div className={classes.hero}>
      <div className={classes.doodle}>
        <IconPlane size={18} stroke={1.75} />
        <span>{getStringRes("home.hero.tagline")}</span>
      </div>
      <h1 className={classes.title}>{getStringRes("home.hero.title")}</h1>
      <p className={classes.subtitle}>{getStringRes("home.hero.subtitle")}</p>
      <ul className={classes.benefits}>
        {BENEFITS.map(({ key, icon: Icon }) => (
          <li key={key} className={classes.benefit}>
            <Icon size={16} stroke={1.5} />
            <span>{getStringRes(key)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
